<template>
  <div class="produk">
    <!-- <SearchView />    -->
    <div class="title-bar" style="background-color: #C039FF;" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
      <div class="row text-white" style="padding: 15px 110px;">
        <div class="col-12 col-md-6 text-left" style="font-family: 'Manrope'; font-size: 16px; font-weight: 700;">
          Keranjang
        </div>
        <div class="col-12 col-md-6" style="font-family: 'Poppins'; font-size: 14px; font-weight: 500;">
          <q-breadcrumbs class="text-grey-4" align="right" active-color="white">
            <q-breadcrumbs-el to="/" label="Beranda" />
            <q-breadcrumbs-el label="Keranjang" />
          </q-breadcrumbs>
        </div>
      </div>
    </div>
    <div class="title-bar" style="background-color: #C039FF;" v-if="$q.screen.lt.sm">
        <div class="row text-white" style="padding: 10px 20px;">
        <div class="col-6 text-left" style="font-family: 'Manrope'; font-size: 10px; font-weight: 600;">
          Keranjang
        </div>
        <div class="col-6" style="font-family: 'Poppins'; font-size: 7.5px; font-weight: 500; padding-top: 2.5px;">
          <q-breadcrumbs class="text-grey-4" align="right" active-color="white">
            <q-breadcrumbs-el to="/" label="Beranda" />
            <q-breadcrumbs-el label="Keranjang" />
          </q-breadcrumbs>
        </div>
      </div>
    </div>
    <div style="margin: 50px 100px 25px; border: solid 1px #E9E9E9; border-radius: 5px; background-color: #F7F7F8;" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
      <div class="row text-center" style="margin-bottom: 15px; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 14px; font-weight: 600; background-color: #E9E9E9;">
        <div class="col-12 col-md-3 text-left" style="padding: 15px 0 15px 15px;">
            Produk
        </div>
        <div class="col-12 col-md-3" style="padding: 15px 0">
            Harga
        </div>
        <div class="col-12 col-md-2" style="padding: 15px 0">
            Kuantitas
        </div>
        <div class="col-12 col-md-3" style="padding: 15px 0">
            Total
        </div>
        <div class="col-12 col-md-1" style="padding: 15px 0">
            Aksi
        </div>
      </div>
      <div v-if="cek_data == 1" class="text-center" style="margin: 15px 0; color: #777777; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 14px; font-weight: 400;">
        Belum Ada Produk Dalam Keranjang Anda
      </div>
      <div v-else class="row text-center" v-for="data in list_data" style="margin-bottom: 10px; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 13px; font-weight: 400;">
        <div class="col-12 col-md-3 text-left" style="padding: 15px 0 15px 15px;">
            <q-img :src="file_path+data.produk_file" style="width: 75px; border-radius: 5px; margin-right: 7.5px;"/> {{data.produk_nama}}
        </div>
        <div class="col-12 col-md-3" style="padding: 15px 0">
            Rp. {{data.produk_harga}}
        </div>
        <div class="col-12 col-md-2" style="padding: 15px 0">
            <div class="wrapper">
                <button v-if="data.kuantitas == 1" @click="dlg_hapus = true, selectProduk(data)" class="btn" type="button" name="button">-</button>
                <button v-else class="btn" @click="lessCounter(data)" type="button" name="button">-</button>
                <input class="quantity" type="number" name="kuantitas" v-model="data.kuantitas">
                <button v-if="data.kuantitas == data.produk_stock" disabled class="btn"  type="button" name="button" title="Kuantitas tidak boleh melebih stok">+</button>
                <button v-else class="btn" @click="moreCounter(data)" type="button" name="button">+</button>
            </div>
        </div>
        <div class="col-12 col-md-3" style="padding: 15px 0">
            Rp. {{data.total}}
        </div>
        <div class="col-12 col-md-1" style="padding: 15px 0">
            <q-btn flat round color="purple-12" @click="dlg_hapus = true, selectProduk(data)" icon="delete" size="sm" />
        </div>
      </div>
    </div>
    <div style="margin: 25px 20px 7.5px; border: solid 1px #E9E9E9; border-radius: 5px; background-color: #F7F7F8;" v-if="$q.screen.lt.sm">
      <div class="row text-center" style="margin-bottom: 5px; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 10px; font-weight: 600; background-color: #E9E9E9;">
        <div class="col-3" style="padding: 10px 0;">
            Produk
        </div>
        <div class="col-3" style="padding: 10px 0">
            Harga
        </div>
        <div class="col-2" style="padding: 10px 0">
            Kuantitas
        </div>
        <div class="col-3" style="padding: 10px 0">
            Total
        </div>
        <div class="col-1" style="padding: 10px 0">
            Aksi
        </div>
      </div>
      <div v-if="cek_data == 1" class="text-center" style="margin: 10px 0; color: #777777; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 10px; font-weight: 400;">
        Belum Ada Produk Dalam Keranjang Anda
      </div>
      <div v-else class="row text-center" v-for="data in list_data" style="margin-bottom: 10px; font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 10px; font-weight: 400;">
        <div class="col-3 text-no-wrap overflow-hidden cursor-pointer q-hoverable" @click="push_produk(data.produk_id)" style="margin: 5px 0; text-overflow: ellipsis;">
            <q-img :src="file_path+data.produk_file" style="width: 45px; height: 35px; border-radius: 5px; margin: 0 5px ;"/>{{data.produk_nama}}
        </div>
        <div class="col-3" style="margin: 10px 0; padding-top: 4.5px;">
            Rp. {{data.produk_harga}}
        </div>
        <div class="col-2" style="margin: 10px 0">
            <div class="wrapper-android">
                <button v-if="data.kuantitas == 1" @click="dlg_hapus = true, selectProduk(data)" class="btn-android" type="button" name="button">-</button>
                <button v-else class="btn-android" @click="lessCounter(data)" type="button" name="button">-</button>
                <input class="quantity-android" type="number" name="kuantitas" v-model="data.kuantitas">
                <button v-if="data.kuantitas == data.produk_stock" disabled class="btn-android"  type="button" name="button" title="Kuantitas tidak boleh melebih stok">+</button>
                <button v-else class="btn-android" @click="moreCounter(data)" type="button" name="button">+</button>
            </div>
        </div>
        <div class="col-3" style="margin: 10px 0; padding-top: 4.5px;">
            Rp. {{data.total}}
        </div>
        <div class="col-1" style="margin: 5px 0">
            <q-btn flat round color="purple-12" @click="dlg_hapus = true, selectProduk(data)" icon="delete" size="sm" />
        </div>
      </div>
    </div>
    <div class="row" style="margin: 0 100px 75px;" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
        <div class="col-12 col-md-6">
            <q-btn no-caps flat to="/produk" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 16px; font-weight: 400; color: #C039FF; " class="btn--no-hover" label="Lanjut Belanja" />
        </div>
        <div v-if="cek_data == 1" class="col-12 col-md-6 text-right">
            <!-- <q-btn no-caps color="purple-12" to="/checkout" label="Checkout" style="font-family: 'Manrope'; font-size: 14px; font-weight: bold;" /> -->
        </div>
        <div v-else class="col-12 col-md-6 text-right">
            <q-btn no-caps color="purple-12" to="/checkout" label="Checkout" style="font-family: 'Manrope'; font-size: 14px; font-weight: bold;" />
        </div>
    </div>
    <div class="row" style="margin: 0 20px 0 5px;" v-if="$q.screen.lt.sm">
        <div class="col-6">
            <q-btn no-caps flat to="/produk" style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 10px; font-weight: 400; color: #C039FF; " class="btn--no-hover" label="Lanjut Belanja" />
        </div>
        <div v-if="cek_data == 1" class="col-6 text-right">
            <!-- <q-btn no-caps color="purple-12" to="/checkout" label="Checkout" style="font-family: 'Manrope'; font-size: 7.5px; font-weight: bold;" /> -->
        </div>
        <div v-else class="col-6 text-right">
            <q-btn no-caps color="purple-12" to="/checkout" label="Checkout" style="font-family: 'Manrope'; font-size: 7.5px; font-weight: bold;" />
        </div>
    </div>
    <div style="margin: 0 100px 75px; padding-top: 75px; border-style: solid none none none; border-color: #E9E9E9; border-width: 1px;" v-if="$q.screen.sm || $q.screen.md || $q.screen.lg || $q.screen.xl">
      <div class="row" style="margin-bottom: 25px;">
            <div class="col-12 col-md-6 produk-title1">
                Produk Populer
                </div>
            <div class="col-12 col-md-6" style="text-align: right;">
                <q-btn to="/produk" flat no-caps color="purple-12">
                    <div class="produk-title2">Lihat Semua Produk</div>
                    <div class="produk-btn">
                    <span class="material-symbols-outlined">
                        arrow_right_alt
                    </span>
                    </div>
                </q-btn>
            </div>
        </div>
        <div class="row items-start q-col-gutter-md">
        <div class="col-12 col-md-3" v-for="data in produk_populer">
            <q-card v-ripple class="my-card cursor-pointer q-hoverable" @click="push_produk(data.id)">
                <q-img :src="file_path+data.file" height="275px">
                    <template v-slot:loading>
                    <div class="text-purple-12">
                        <q-spinner-ios />
                    </div>
                    </template>
                </q-img>

                <q-card-section style="text-align: center;">
                    <q-btn
                    round
                    color="white"
                    icon="shopping_cart"
                    text-color="purple-12"
                    size="sm"
                    style="top: -15px; transform: translateY(-50%);"
                    />
                    <div class="produk-cat">
                    {{data.kategori_uraian}}
                    </div>
                    <div style="padding-bottom: 15px;">
                    <q-rating
                    v-model="model1"
                    max="5"
                    size="1em"
                    color="purple-12"
                    icon="star_border"
                    icon-selected="star"
                    icon-half="star_half"
                    />
                    </div>
                    <q-btn no-caps flat @click="push_produk(data.id)" style="font-family: 'Poppins'; font-size: 16px; font-weight: 600; color: #2B2B2D; padding-bottom: 15px;" class="btn--no-hover" :label="data.brand" />
                    <div class="produk-price1">Rp. {{data.harga}} <span class="produk-price2"> Rp. {{data.harga}}</span></div>
                </q-card-section>
            
            </q-card>
        </div>
        </div>
    </div>
    <div style="margin: 25px 20px; padding-top: 25px; border-style: solid none none none; border-color: #E9E9E9; border-width: 1px;" v-if="$q.screen.lt.sm">
      <div class="row" style="margin-bottom: 5px;">
            <div class="col-6 produk-title1-android">
                Produk Populer
                </div>
            <div class="col-6" style="text-align: right;">
                <q-btn to="/produk" flat no-caps color="purple-12" style="margin-top: -10px; margin-right: -15px;">
                    <div class="produk-title2-android">Lihat Semua Produk</div>
                    <div class="produk-btn-android">
                    <span class="material-symbols-outlined">
                        arrow_right_alt
                    </span>
                    </div>
                </q-btn>
            </div>
        </div>
        <div class="row items-start q-col-gutter-xs">
        <div class="col-3" v-for="data in produk_populer">
            <q-card v-ripple class="my-card cursor-pointer q-hoverable" @click="push_produk(data.id)">
                <q-img :src="file_path+data.file" height="100px">
                    <template v-slot:loading>
                    <div class="text-purple-12">
                        <q-spinner-ios />
                    </div>
                    </template>
                </q-img>

                <q-card-section style="text-align: center;">
                    <q-btn
                    round
                    color="white"
                    icon="shopping_cart"
                    text-color="purple-12"
                    size="xs"
                    style="top: -15px; transform: translateY(-50%);"
                    />
                    <div class="produk-cat-android text-no-wrap overflow-hidden" style="text-overflow: ellipsis;">
                    {{data.kategori_uraian}}
                  </div>
                  <div style="margin-top: -5px;">
                    <q-rating
                    v-model="model1"
                    max="5"
                    size="0.5em"
                    color="purple-12"
                    icon="star_border"
                    icon-selected="star"
                    icon-half="star_half"
                    />
                    </div>
                    <div class="text-center text-no-wrap overflow-hidden produk-android-title" style="text-overflow: ellipsis;">
                        {{ data.brand }}
                      </div>
                      <div class="produk-price1-android">Rp. {{data.harga}} <span class="produk-price2-android text-no-wrap overflow-hidden" style="text-overflow: ellipsis;"> Rp. {{data.harga}}</span></div>
                </q-card-section>
            
            </q-card>
        </div>
        </div>
    </div>
    <q-dialog v-model="dlg_hapus" persistent>
      <q-card>
        <q-card-section class="row items-center" style="background-color: #F7F7F8;">
          <div class="produk-cat">
          <span class="q-ma-sm" style="font-size: 14px;">Apakah Anda yakin untuk menghapus produk dari keranjang ?</span>
          </div>
        </q-card-section>

        <q-card-actions class="row" align="center">
          <div class="col-6 col-md-6 text-center">
            <q-btn flat no-caps label="Tidak" color="grey-7" v-close-popup />
          </div>
          <div class="col-6 col-md-6 text-center">
            <q-btn flat @click="hapusProduk(form.id)" no-caps label="Ya" color="purple-12" v-close-popup />
          </div>
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>

import { ref } from 'vue'
// import SearchView from '@/views/SearchView.vue'
import { func } from 'joi';

export default {
  name: 'ProdukView',
  // components: {
  //   SearchView
  // },
  data () {
    return {
      form : {
        id : '',
        produkId : '',
        kategoriId : '',
        kuantitas : '',
        total : '',
        stock : '',
      },
      dlg_hapus : false,
      counter: 1,
      tabs: ref('all'),
      current: ref(1),
      produk_populer : [],
      cek_data : '',

      file_path: this.$store.state.url.URL_APP + "uploads/",
    }
  },
  methods: {

    push_produk : function(id){
      this.$router.push('/produk_detail/'+id);
    },

    getView : function(){
      this.$store.commit('showLoading');
      fetch(this.$store.state.url.URL_KERANJANG  + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          }
      })
          .then(res => res.json())
          .then(res_data => {
            console.log(res_data);
              this.list_data = res_data.data;
              this.$store.commit("hideLoading");
              console.log(this.list_data);
              if (this.list_data.length === 0 ) {
                this.cek_data = 1
              }
      });
    },

    lessCounter : function(data) {
      this.form.id = data.id
      this.form.produkId = data.produk_id
      this.form.kategoriId = data.kategori_id
      this.form.kuantitas = data.kuantitas-1
      this.form.harga = data.produk_harga
      this.form.total = (data.kuantitas-1)*data.produk_harga
      this.form.stock = data.produk_stock

      this.getCounter();
    },

    moreCounter : function(data) {
      this.form.id = data.id
      this.form.produkId = data.produk_id
      this.form.kategoriId = data.kategori_id
      this.form.kuantitas = data.kuantitas+1
      this.form.harga = data.harga
      this.form.total = (data.kuantitas+1)*data.produk_harga
      this.form.stock = data.produk_stock
      this.getCounter();
    },

    selectProduk : function(data) {
      this.form.id = data.id
    },

    getCounter : function(){
      fetch(this.$store.state.url.URL_KERANJANG  + "counter", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
        this.getView();
        setTimeout(function(){
            location.reload();
        }, 50);
      });
    },

    hapusProduk : function(a){
      fetch(this.$store.state.url.URL_KERANJANG  + "hapusProduk", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : a})
      }).then(res_data => {
          this.Notify('Produk Dihapus Dari Keranjang', 'purple-12', 'check_circle_outline');
          this.getView();
      });

    },

    getProdukPopuler : function(){
      fetch(this.$store.state.url.URL_PRODUK  + "produkPopuler", {
          method: "POST",
          headers: {
          "content-type": "application/json"
          },
      })
          .then(res => res.json())
          .then(res_data => {
            console.log(res_data);
              this.produk_populer = res_data.data;
      });
    },

    Notify : function(message, color, icon){
          this.$q.notify({
            message: message,
            color: color,
            icon: icon,
            position : 'center',
            timeout: 500,
          })
        },

  },

  mounted() {
    this.getView();
    this.getProdukPopuler();
  }
}
</script>
